import { DatePickerContent } from './date-picker-content';
import { DatePicker as InnerDatePicker } from './date-picker';
const DatePicker = InnerDatePicker;
DatePicker.Content = DatePickerContent;
export default DatePicker;
